var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"text-h5 pa-0 black--text font-weight-bold"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }